import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Loader2 } from 'lucide-react';
import { authApi } from '@/services/api/auth';
import { useAuthStore } from '@/stores/auth';

export function SignIn() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { setSession } = useAuthStore();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const s = await authApi.login(email);
      setSession(s);
      navigate('/', { replace: true });
    } catch (err: any) {
      setError(err?.message ?? 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-full flex-col px-6 py-8">
      <div className="flex items-center gap-2 mb-10">
        <Sparkles className="h-6 w-6 text-brand-500" />
        <h1 className="text-lg font-semibold">AI動画生成サービス</h1>
      </div>

      <div className="flex-1 flex flex-col justify-center max-w-sm mx-auto w-full">
        <h2 className="text-2xl font-semibold mb-2">サインイン</h2>
        <p className="text-sm text-slate-400 mb-6">
          メールアドレスでサインインしてください。初回は自動でアカウントを作成します。
        </p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label">メールアドレス</label>
            <input
              type="email"
              required
              autoComplete="email"
              inputMode="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              placeholder="you@example.com"
            />
          </div>
          {error && <div className="text-sm text-red-400">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            サインイン
          </button>
        </form>
      </div>

      <p className="text-xs text-slate-500 text-center mt-6 pb-safe">
        続行することで
        <a className="text-brand-400 underline mx-1" href="/terms">利用規約</a>
        と
        <a className="text-brand-400 underline mx-1" href="/privacy">プライバシーポリシー</a>
        に同意したものとみなします。
      </p>
    </div>
  );
}
